import { render } from "./azureFile.vue?vue&type=template&id=3d932c24"
import script from "./azureFile.vue?vue&type=script&lang=js"
export * from "./azureFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__